var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "img"
    ? _c("img", {
        attrs: { src: _vm.imgSrc, alt: _vm.imgAlt },
        on: {
          load: function ($event) {
            return _vm.imgLoad($event)
          },
          error: function ($event) {
            return _vm.imgError($event)
          },
        },
      })
    : _c(
        "div",
        {
          style: {
            backgroundImage: _vm.imgSrc ? "url(" + _vm.imgSrc + ")" : null,
            backgroundSize: _vm.backSize,
            backgroundPosition: _vm.backPos,
            backgroundColor: _vm.imgSrc ? "" : _vm.bgColor,
          },
          attrs: {
            role: _vm.imgAlt && "img",
            title: _vm.imgAlt,
            "aria-label": _vm.imgAlt,
          },
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }